/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Nudge_LinkInputs */



/**
* | output |
* | --- |
* | "Show me how" |
*
* @param {Install_Nudge_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const install_nudge_link = /** @type {((inputs?: Install_Nudge_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Nudge_LinkInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeig mir, wie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Me montrer comment")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("查看方法")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("查看方法")
	if (locale === "ko") return /** @type {LocalizedString} */ ("방법 보기")
	return /** @type {LocalizedString} */ ("Show me how")
});